import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SearchField from "./SearchField";

const images = [
  "/assets/png/WhatsApp-Image-2021-03-26-at-7.34.26-PM-1-600x1062.jpeg",
  "/assets/png/IMG_20230303_183154.jpg",
];

export default function Slideshow() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="vp-page">

      {/* ── Navbar ───────────────────────────────────────────────── */}
      <nav className="vp-navbar">
        <div className="vp-navbar__inner">
          <a href="https://tuvpak.com/" target="_blank" rel="noreferrer" className="vp-navbar__brand">
            <img src="/assets/logo/color_logo.png" alt="TUV PAK" className="vp-navbar__logo" />
            <span className="vp-navbar__name">TUV PAK</span>
          </a>
          <div className="vp-navbar__links">
            <a href="https://tuvpak.com/" target="_blank" rel="noreferrer">Home</a>
            <a href="https://tuvpak.com/services/" target="_blank" rel="noreferrer">Services</a>
            <a href="https://tuvpak.com/about-us/" target="_blank" rel="noreferrer">About</a>
            <Link to="/login" className="vp-navbar__btn">Admin Login</Link>
          </div>
        </div>
      </nav>

      {/* ── Hero ─────────────────────────────────────────────────── */}
      <div className="vp-hero">
        {/* Background image */}
        <div
          className="vp-hero__bg"
          style={{ backgroundImage: `url(${images[currentIndex]})` }}
        />
        {/* Dark overlay */}
        <div className="vp-hero__overlay" />

        {/* Hero content */}
        <div className="vp-hero__content">
          <div className="vp-hero__badge">
            <span className="vp-hero__badge-dot" />
            Official Document Verification Portal
          </div>
          <h1 className="vp-hero__title">
            Verify Your <span className="vp-hero__title--accent">Certification</span>
          </h1>
          <p className="vp-hero__subtitle">
            TUV PAK Inspection Services — trusted third-party inspection,
            testing &amp; calibration since 2015. Enter your unique certificate
            ID below to instantly verify its authenticity.
          </p>

          {/* Search box */}
          <SearchField />

          {/* Trust badges */}
          <div className="vp-hero__badges">
            <div className="vp-hero__trust">
              <span className="vp-hero__trust-icon">✓</span> ISO Certified
            </div>
            <div className="vp-hero__trust">
              <span className="vp-hero__trust-icon">✓</span> API &amp; ASME Standards
            </div>
            <div className="vp-hero__trust">
              <span className="vp-hero__trust-icon">✓</span> AWS · CSWIP · NACE
            </div>
          </div>
        </div>

        {/* Slide dots */}
        <div className="vp-hero__dots">
          {images.map((_, i) => (
            <button
              key={i}
              className={`vp-hero__dot${i === currentIndex ? " vp-hero__dot--active" : ""}`}
              onClick={() => setCurrentIndex(i)}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
      </div>

      {/* ── Info strip ───────────────────────────────────────────── */}
      <div className="vp-strip">
        <div className="vp-strip__inner">
          <div className="vp-strip__item">
            <span className="vp-strip__icon">🔍</span>
            <div>
              <strong>Enter Certificate ID</strong>
              <p>Type the unique ID printed on your certificate</p>
            </div>
          </div>
          <div className="vp-strip__divider" />
          <div className="vp-strip__item">
            <span className="vp-strip__icon">🛡️</span>
            <div>
              <strong>Instant Verification</strong>
              <p>Our system checks against the official registry</p>
            </div>
          </div>
          <div className="vp-strip__divider" />
          <div className="vp-strip__item">
            <span className="vp-strip__icon">📄</span>
            <div>
              <strong>Download Document</strong>
              <p>Download your verified certificate in seconds</p>
            </div>
          </div>
        </div>
      </div>

      {/* ── Footer ───────────────────────────────────────────────── */}
      <footer className="vp-footer">
        <div className="vp-footer__inner">
          <div className="vp-footer__brand">
            <strong>TUV PAK Inspection Services</strong>
            <span>Established April 2015 · Pakistan</span>
          </div>
          <div className="vp-footer__links">
            <a href="https://tuvpak.com/" target="_blank" rel="noreferrer">tuvpak.com</a>
            <span>·</span>
            <Link to="/login">Admin Portal</Link>
          </div>
          <div className="vp-footer__copy">
            © {new Date().getFullYear()} TUV PAK. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
}
